import React, { memo } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/AddCircleRounded';
import { Link } from 'react-router-dom';

const NewVideoButton = () => {
  return (
    <Link to="/create" style={{ textDecoration: 'none' }}>
      <Button variant="outlined" color="primary" startIcon={<AddIcon />}>
        New Video
      </Button>
    </Link>
  );
}

export default memo(NewVideoButton);
